module.exports = __webpack_public_path__ + "static/media/new-arrivals-color.f1aef732.svg";